const ROLE_PALETTES = {
  ADMIN: {
    light: { bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA" },
    dark: { bg: "#7F1D1D22", text: "#FCA5A5", border: "#EF444440" },
  },
  EDITOR: {
    light: { bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" },
    dark: { bg: "#1E3A8A22", text: "#93C5FD", border: "#3B82F640" },
  },
  VIEWER: {
    light: { bg: "#F8FAFC", text: "#475569", border: "#E2E8F0" },
    dark: { bg: "#33415522", text: "#CBD5E1", border: "#64748B40" },
  },
};

export function getRolePalette(role, dark) {
  const entry = ROLE_PALETTES[role] ?? ROLE_PALETTES.VIEWER;
  return dark ? entry.dark : entry.light;
}
